import { ProviderConfig } from 'launchdarkly-react-client-sdk/lib/types';
import { User } from 'auth';
import { appConfig } from 'config/app';

export const getProviderConfig = (user: User): ProviderConfig => {
  const { userAccountId, identity, roles = [] } = user;

  const email = identity?.email;

  return {
    clientSideID: appConfig.featureFlagsSiteId,
    context: {
      kind: 'user',
      key: userAccountId,
      email,
      custom: {
        roles: Array.from(new Set(roles.map((role) => role.key))),
        hostname: window.location.hostname,
      },
    },
  };
};

/**
 * Builds the LaunchDarkly provider config for a jobsite-scoped feature-flag
 * provider. Uses a multi-kind context (user + jobsite) when a user is present,
 * so both user- and jobsite-targeted flags evaluate; falls back to a
 * jobsite-only context when logged out (e.g. unauthenticated self-onboarding),
 * which lets jobsite-scoped flags be evaluated client-side without a user.
 */
export const getJobsiteProviderConfig = (
  jobsiteId: string,
  user?: User,
): ProviderConfig => {
  const { userAccountId, identity, roles = [] } = user ?? {};
  const email = identity?.email;

  return {
    clientSideID: appConfig.featureFlagsSiteId,
    context: userAccountId
      ? {
          kind: 'multi',
          user: {
            key: userAccountId,
            email,
            custom: {
              roles: Array.from(new Set(roles.map((role) => role.key))),
              hostname: window.location.hostname,
            },
          },
          jobsite: { key: jobsiteId },
        }
      : { kind: 'jobsite', key: jobsiteId },
  };
};

export const areFeatureFlagsEnabled = (): boolean =>
  !!appConfig.featureFlagsSiteId;
